import script from "./BacktestStatusOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./BacktestStatusOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./BacktestStatusOverlay.vue?vue&type=style&index=0&id=5409429a&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5409429a"]])

export default __exports__